import Routes from "@Routes";
import { callService } from "@Views/utils/ServiceUtils";
import { isEmpty } from "@Views/utils/StringUtils";
import axios from "axios";
import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import i18n from '@Lang/i18n';

Highcharts.setOptions({ lang: { thousandsSep: ",", decimalPoint: '.' } })

const App = () => {

  const [load, setLoad] = useState((isEmpty(localStorage.getItem('ipAddr')) === false && isEmpty(sessionStorage.getItem('_recruitScrLoad')) === false));

  const loadData = async () => {
    if (!localStorage.getItem('ipAddr')) {
      const res = await axios.get("/serviceEndpoint/ipcheck");

      localStorage.setItem('ipAddr', res['data']);
    }

    const scrLoad = sessionStorage.getItem('_recruitScrLoad');

    if (isEmpty(scrLoad)) {
      const res = await callService('OSUSE07R01', { scrId: 'RECRUIT', useYn: 'Y' });

      if (res['scrList']) {
        for (const scrInfo of res['scrList']) {
          sessionStorage.setItem('_/recruit/#' + scrInfo['scrFilePathCtnt'], scrInfo['scrId']);
        }
      }

      sessionStorage.setItem('_recruitScrLoad', "true");
    }

    setLoad(true);
  }

  useEffect(() => {
    if (load === false) {
      loadData();

      const lang = 'ko';
      i18n.changeLanguage(lang);
      localStorage.setItem("lang", lang);
    }
  }, [])

  return (
    <>
      {load && <Routes />}
    </>
  );
}

export default App;